import { GraphQLQueryClass } from "@bsm/component";
import { TUserStudentFamiliesResponse, TUserStudentFamily } from "@bsm/graphql";

export class UserStudentFamiliesQuery
    implements GraphQLQueryClass<TUserStudentFamiliesResponse, TResponse> {
    public queryKey: string = "App.Bsm.Invoices.UserStudentFamiliesQuery";
    public gql: string = `
        query UserStudentFamiliesQuery(
            $key: String
            $pageSize: Float,
            $page: Float,
            $data: JSONObject
            $sort: [TFilterSort!]
            
        ){
            userStudentFamilies (filter: {
                key: $key
                data: $data,
                pageSize: $pageSize,
                page: $page,
                sort: $sort
            }){
                total
                data {
                    id
                    designation
                    fatherName
                    motherName
                    updatedAt
                    members { 
                        type 
                        student {
                            id isEnrolled user { id fullName }
                        }
                    }
                    currencies {
                        id descriptorKey translationKey comment value
                    }
                }
            }
        }
    `;
    variables?: any;

    constructor(variables: any) {
        this.variables = variables;
    }
    mapFn(data: TResponse): TUserStudentFamiliesResponse {
        return {
            total: data.userStudentFamilies.total,
            data: data.userStudentFamilies.data,
        };
    }
}

export type TResponse = {
    userStudentFamilies: {
        total: number;
        data: Array<TUserStudentFamily>;
    };
};
